import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/agriculture";

/** Agriculture page — agriculture.bizlem.com */
export default function AgriculturePage() {
  return <SubdomainSite config={config} />;
}

export { config };
